export class NotificationInfo {
    public workItemId: string;
    public step: string;
    public recipients: string;
    public trackingId: string;
    public emailMessageType: string;
    public subject: string;
}

export class SentNotificationInfo extends NotificationInfo {
    public dateSent: string;
}

export class UnsentNotificationInfo extends NotificationInfo {
    public queueDate: string;
    public attempts: number;
    public nextAttempt: string;
}